<template>
  <div class="login-cont" :class="[{'login-iframe': isPopup}]">
    <!-- 登录表单视图 -->
    <div v-if="!isLogin">
      <iframe
        ref="myIframe"
        :src="iframeSrc"
        class="iframe"
        :class="[{'block': showIframe}, {'fix': type === 1}]"
      ></iframe>
      <img
        v-if="isPopup"
        src="./img/close-pop.png"
        alt="关闭"
        class="close-btn"
        @click="close"
      >
    </div>

    <!-- 登录成功视图 -->
    <div v-else class="succ-container" :class="[{'succ-pop': isLogin && isPopup}]">
      <!-- LP 专属二维码视图 -->
      <template v-if="successViewType === 'lp-qrcode'">
        <h3>添加班主任老师微信</h3>
        <img :src="imgSrc" alt="二维码" class="code-img" @error="handleImageError">
        <h4>立即微信扫码添加</h4>
        <div class="benefit-tags">
          <div class="tag">
            <div class="tag-number-lp">及时了解孩子</div>
            <div class="tag-desc-lp">学情报告</div>
          </div>
          <div class="tag">
            <div class="tag-number-lp">及时解答各种</div>
            <div class="tag-desc-lp">疑难问题</div>
          </div>
        </div>
        <div class="btn btn-lp" @click="linkTo">确认</div>
      </template>

      <!-- 默认成功视图 -->
      <template v-else-if="successViewType === 'default'">
        <h3>您已成功申请试听课</h3>
        <img src="./img/code-default.png" alt="成功">
        <div class="benefit-tags">
          <div class="tag">
            <div class="tag-number">30节</div>
            <div class="tag-desc">亲子外教口语课</div>
          </div>
          <div class="tag">
            <div class="tag-number">10G</div>
            <div class="tag-desc">英语电子版资料</div>
          </div>
        </div>
        <div class="btn" @click="linkTo">立即添加助教</div>
      </template>

      <!-- LP 默认视图 -->
      <template v-else-if="successViewType === 'lp-default'">
        <h3>您已成功申请试听课</h3>
        <img src="./img/code-lp-default.png" alt="成功">
        <div class="benefit-tags">
          <div class="tag">
            <div class="tag-number">30节</div>
            <div class="tag-desc">亲子外教口语课</div>
          </div>
          <div class="tag">
            <div class="tag-number">10G</div>
            <div class="tag-desc">英语电子版资料</div>
          </div>
        </div>
        <div class="btn" @click="linkTo">立即添加助教</div>
      </template>
    </div>
  </div>
</template>
<script>
import tools from '@/utils/tools'
import { commonApi } from '@/utils/api';
import cookies from "cookies-js";

// 常量配置
const IFRAME_CONFIG = {
  LOGIN_URL: 'https://mobile.vipkid.com.cn/entry/newwwwh5login',
  HEIGHT_FIX: 322,
  HEIGHT_DEFAULT: 334,
  LOAD_DELAY: 500
};

const COOKIE_CONFIG = {
  EXPIRES_DAYS: 7,
  PATH: '/'
};

const VIEW_TYPES = {
  DEFAULT: 'default',
  LP_QRCODE: 'lp-qrcode',
  LP_DEFAULT: 'lp-default'
};

export default {
  name: 'LoginIframe',

  props: {
    isPopup: {
      type: Boolean,
      required: true
    },
    channelId: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      iframeSrc: '',
      imgSrc: '',
      showIframe: false,
      isLogin: false,
      successViewType: VIEW_TYPES.DEFAULT, // 成功页面的显示类型
      resizeHandler: null,
      messageHandler: null
    }
  },

  mounted() {
    this.initIframe();
    this.initMessage();
    this.initResizeListener();
  },

  beforeDestroy() {
    // 清理事件监听器，防止内存泄漏
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }
  },

  methods: {
    /**
     * 初始化 iframe
     */
    initIframe() {
      const path = tools.getMatch(location.pathname);
      const adultIdentify = path.includes('bigstar') ? 1 : 0;

      // 构建 iframe URL
      const src = new URL(IFRAME_CONFIG.LOGIN_URL);
      src.searchParams.append('path', path);
      src.searchParams.append('channel_id', this.channelId);
      src.searchParams.append('adultIdentify', adultIdentify);

      // 特殊处理剑桥考试相关页面
      if (['/cambLevel', '/cambKPFLevel'].some(item => location.href.includes(item))) {
        src.searchParams.append('cambSource', 'camb');
      }

      this.iframeSrc = src.toString();

      // 等待 iframe 加载完成后设置高度
      this.$nextTick(() => {
        this.setupIframeLoad();
      });
    },

    /**
     * 设置 iframe 加载完成后的处理
     */
    setupIframeLoad() {
      if (!this.$refs.myIframe) return;

      this.$refs.myIframe.style.height = 0;
      this.$refs.myIframe.onload = () => {
        setTimeout(() => {
          if (this.$refs.myIframe) {
            const height = this.type === 1 ? IFRAME_CONFIG.HEIGHT_FIX : IFRAME_CONFIG.HEIGHT_DEFAULT;
            this.$refs.myIframe.style.height = `${height}px`;
          }

          // iframe 加载完成后发送消息
          this.sendMessageToIframe();
        }, IFRAME_CONFIG.LOAD_DELAY);
      };
    },

    /**
     * 向 iframe 发送消息
     */
    sendMessageToIframe() {
      if (this.$refs.myIframe?.contentWindow) {
        this.$refs.myIframe.contentWindow.postMessage('bodyclick', '*');
      }
    },

    /**
     * 初始化消息监听
     */
    initMessage() {
      this.messageHandler = async (event) => {
        const data = event.data;

        if (!data) return;

        // iframe 加载完成
        if (data.msg === 'entry/loaded') {
          this.showIframe = true;
          return;
        }

        // 登录成功
        if (data.code === 200 && data.msg === 'entry/logincenter') {
          await this.handleLoginSuccess(data.data);
        }
      };

      window.addEventListener('message', this.messageHandler, false);
    },

    /**
     * 处理登录成功
     */
    async handleLoginSuccess(userData) {
      // 更新页面样式
      const firstElement = document.querySelector('.first');
      if (firstElement) {
        firstElement.classList.add('second');
      }

      // 保存认证信息到 cookies
      this.saveAuthCookies(userData);

      // 获取并显示成功页面
      if (userData.studentId) {
        await this.fetchAndShowSuccessView(userData.studentId);
      } else {
        this.showSuccessView(VIEW_TYPES.DEFAULT);
      }
    },

    /**
     * 保存认证信息到 cookies
     */
    saveAuthCookies(userData) {
      const cookieOptions = {
        expires: COOKIE_CONFIG.EXPIRES_DAYS,
        path: COOKIE_CONFIG.PATH
      };

      if (userData.studentId) {
        cookies.set('m_student_Id', userData.studentId, cookieOptions);
      }

      if (userData.parentId) {
        cookies.set('m_parent_Id', userData.parentId, cookieOptions);
      }

      const token = userData.token || userData.parentToken;
      if (token) {
        cookies.set('m_parent_token', token, cookieOptions);
      }
    },

    /**
     * 获取并显示成功视图
     */
    async fetchAndShowSuccessView(studentId) {
      try {
        const res = await commonApi.get(
          `/rest/gw/parent-portal/api/h5/web/popup/lt/family/lp?studentId=${studentId}`
        );

        // 如果有 LP 信息，尝试获取二维码
        if (res.data && res.data.length > 0) {
          await this.fetchQRCode(res.data[0]);
        } else {
          this.showSuccessView(VIEW_TYPES.DEFAULT);
        }
      } catch (error) {
        this.showSuccessView(VIEW_TYPES.DEFAULT);
      }
    },

    /**
     * 获取二维码
     */
    async fetchQRCode(staffId) {
      try {
        const res = await commonApi.get(
          `/rest/gw/parent-portal/api/h5/web/popup/only/getQrcode?staffId=${staffId}`
        );

        if (res.data && res.data.length > 0) {
          this.imgSrc = res.data;
          this.showSuccessView(VIEW_TYPES.LP_QRCODE);
        } else {
          this.showSuccessView(VIEW_TYPES.LP_DEFAULT);
        }
      } catch (error) {
        this.showSuccessView(VIEW_TYPES.LP_DEFAULT);
      }
    },

    /**
     * 显示成功视图
     */
    showSuccessView(viewType) {
      this.isLogin = true;
      this.successViewType = viewType;
    },

    /**
     * 处理图片加载错误
     */
    handleImageError() {
      this.successViewType = VIEW_TYPES.DEFAULT;
    },

    /**
     * 跳转到家长端首页
     */
    linkTo() {
      window.location.href = '/parents/home';
    },

    /**
     * 关闭弹窗
     */
    close() {
      this.$emit('close');
    },

    /**
     * 初始化窗口大小监听
     */
    initResizeListener() {
      this.resizeHandler = () => {
        this.adjustCloseButtonPosition();
      };

      window.addEventListener('resize', this.resizeHandler);
      this.adjustCloseButtonPosition();
    },

    /**
     * 调整关闭按钮位置
     */
    adjustCloseButtonPosition() {
      this.$nextTick(() => {
        const closeBtn = this.$el?.querySelector('.close-btn');
        if (closeBtn) {
          closeBtn.style.bottom = window.innerHeight < 700 ? '20%' : '23%';
        }
      });
    }
  }
}
</script>
<style scoped lang="less">
.login-iframe{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 90;
}
.close-btn{
  position: fixed;
  bottom: 23%;
  left: calc(50% - 9px);
  width: 18px;
  height: 18px;
  z-index: 92;
}
.iframe{
  display: none;
  border: none;
  margin:0;
  padding:0;
  border-radius: 16px;
  position: absolute;
  top: 24%;
  left: 50%;
  z-index: 91;
  transform: translate(-50%, -50%);
  width: 343px;
  height: 334px;
}
.fix{
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 92;
  transform: translate(-50%, -50%);
  height: 322px;
}
.block{
  display: block;
}
.succ-container{
  background-color: #fff;
  border-radius: 16px;
  text-align: center;
  position: absolute;
  top: -7.5%;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 343px;
  box-shadow: 0 5px 20px rgba(248, 84, 21, 0.15);
  padding: 20px 0;
  z-index: 92;
  h3{
    margin: 0;
    color: rgba(248, 84, 21, 1);
    font-size: 26px;
    line-height: 32px;
    padding-top: 0;
    font-weight: 700;
  }
  h4{
    margin-bottom: 16px;
    color: #000000;
    font-size: 14px;
    line-height: 20px;

    font-weight: 400;
  }
  img{
    width: 120px;
    height: 120px;
    margin: 16px 0 20px
  }
  .code-img{
    width: 120px;
    height: 120px;
    margin: 16px 0 0
  }
  p{
    padding: 0 10px;
    font-size: 15px;
    line-height: 22.5px;
    color: rgba(47, 51, 56, 1);
    font-weight: 500;
  }
  .benefit-tags{
    display: flex;
    justify-content: center;
    margin: 0 16px 16px;

    .tag{
      border-radius: 10px;
      padding: 8px 12px;
      width: 130px;
      position: relative;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:first-child{
        margin-right: 16px;
        background-image: url('./img/10g.png');

        .tag-number{
          text-align: left;
          color: #2C83FF;
          font-size: 20px;
          font-weight: 600;
        }
        .tag-desc{
          font-size: 16px;
          text-align: left;
          color: #3A3837;
        }
        .tag-number-lp{
          text-align: left;
          color: #2C83FF;
          font-size: 14px;
          font-weight: 600;
        }
        .tag-desc-lp{
          font-size: 14px;
          text-align: left;
          color: #2C83FF;
          font-weight: 600;
        }
      }

      &:last-child{
        background-image: url('./img/30jie.png');
        .tag-number{
          text-align: left;
          color: #A64CFF;
          font-size: 20px;
          line-height: 28px;
          font-weight: 600;
        }
        .tag-desc{
          font-size: 16px;
          text-align: left;
          color: #3A3837;
        }

        .tag-number-lp{
          text-align: left;
          color: #A64CFF;
          font-size: 14px;
          font-weight: 600;
        }
        .tag-desc-lp{
          font-size: 14px;
          text-align: left;
          color: #A64CFF;
          font-weight: 600;
        }
      }
    }
  }
  .btn{
    background-color: rgba(248, 84, 21, 1);
    color: #fff;
    border-radius: 8px;
    height: 42px;
    line-height: 42px;
    font-size: 18px;
    font-weight: 500;
    margin: 0 13px 0;
  }
  .btn-lp{
    width:114px;
    margin: 0 auto;
  }
}
.succ-pop{
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  z-index: 92 !important;
  transform: translate(-50%, -50%) !important;
  width: 313px;
  margin: 0 !important;
}
</style>
